import { FC, useCallback, useState, useEffect } from 'react';
import { isIOS, isSafari, isMobileSafari, isMobile } from 'react-device-detect';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Box, Typography } from '@mui/material';
import Image from 'next/legacy/image';
import { smartAppBannerStyles } from './smart-app-banner.styles';
import sweatpalsIcon from '../../../public/assets/icons/sweatpals-icon.svg';
import useLink from '../../../utils/hooks/useLink';
import { FEATURE_AUTO_OPEN_APP, FEATURE_CUSTOM_SMART_BANNER_ON_IOS } from 'constants/features';
import { Showable, useStyles } from '@sweatpals/react-ui-kit';

export interface SmartAppBannerProps {
	userName?: string;
	eventAlias?: string;
	shortLocalInstance?: string;
	hide?: boolean;
}

const SmartAppBanner: FC<SmartAppBannerProps> = props => {
	const { eventAlias, shortLocalInstance, userName, hide } = props;

	const [isBannerShown, setShowBanner] = useState(false);
	const styles = useStyles(smartAppBannerStyles);
	const { openDeepLink } = useLink();

	useEffect(() => {
		if (hide) {
			setShowBanner(false);

			return;
		}

		if (typeof window === 'undefined') return;

		const notIosOrSafari = !isIOS || (!isSafari && !isMobileSafari);

		if (isMobile && (notIosOrSafari || FEATURE_CUSTOM_SMART_BANNER_ON_IOS)) {
			setShowBanner(true);
		}
	}, [hide]);

	const handleOpenAppLink = useCallback(
		async (openFallback = true) => {
			console.log({
				isProfilePage: !!userName,
				userName: userName,

				isSpecificEventPage: !!eventAlias && !!shortLocalInstance,
				eventAlias,
				shortLocalInstance,
			})
			openDeepLink(
				{
					isProfilePage: !!userName,
					userName: userName,

					isSpecificEventPage: !!eventAlias && !!shortLocalInstance,
					eventAlias,
					shortLocalInstance,
				},
				openFallback
			);
		},
		[userName, eventAlias, shortLocalInstance, openDeepLink]
	);

	useEffect(() => {
		if (isBannerShown && FEATURE_AUTO_OPEN_APP) {
			handleOpenAppLink(false);
		}
	}, []);

	return (
		<Showable show={isBannerShown}>
			{() => (
				<Box sx={styles.root}>
					<CloseIcon
						sx={{ height: '14px', width: '14px', color: '#B1B1B3' }}
						onClick={() => {
							setShowBanner(false);
						}}
					/>
					<Image
						src={sweatpalsIcon}
						alt='logo'
						width={32}
						height={32}
						style={{ userSelect: 'none' }}
						draggable={false}
					/>

					<Box sx={styles.info}>
						<Typography sx={styles.title}>SweatPals</Typography>
						<Typography sx={styles.description}>Host or join fitness events</Typography>
					</Box>

					<Box sx={styles.button} onClick={() => handleOpenAppLink()}>
						Open
					</Box>
				</Box>
			)}
		</Showable>
	);
};

export default SmartAppBanner;
